import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import ConfirmBtn from '@/components/ConfirmBtn/index.vue';
import { deleteDemand, revocationDemand, revocationDesigner, submitDemand, genBill } from '@/api/demand/demand';
import { startDevTask, revocationConfigure, revocationPlan } from '@/api/demand/interactive';
import { checkPending } from '@/api/demand/demand';

export default {
  name: 'demandControlCell',
  components: {
    ConfirmBtn: ConfirmBtn
  },
  props: {
    isSubmitted: Boolean,
    isAssigned: Boolean,
    isDesignLeader: Boolean,
    loading: Boolean
  },

  data: function data() {
    return {};
  },

  methods: {
    /**
     * 统一处理刷新列表逻辑
     * @param {Object} data 传参对象
     * @param {Function} data.promise promise对象，如删除操作promise等
     * @param {Object/String} data.param promise对象的传参
     * @param {String} data.successMsg 操作成功返回的message
     */
    commonHandler: function commonHandler(data) {
      var _this = this;

      if (typeof data.promise !== 'function') {
        console.error('\u4F20\u53C2promise\u975E\u51FD\u6570');
        return;
      }
      this.$emit('update:loading', true);
      data.promise(data.param).then(function (res) {
        _this.$emit('update:loading', false);
        if (res.data.code === 0) {
          _this.$message({
            message: data.successMsg,
            type: 'success'
          });
          _this.$emit('getDemandList');
        } else {
          _this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      }).catch(function () {
        _this.$emit('update:loading', false);
      });
    },
    showDiscardDemandDialog: function showDiscardDemandDialog() {
      this.$emit.apply(this, ['showDiscardDemandDialog'].concat(Array.prototype.slice.call(arguments)));
    },
    openUpdateDemandDialog: function openUpdateDemandDialog() {
      this.$emit.apply(this, ['openUpdateDemandDialog'].concat(Array.prototype.slice.call(arguments)));
    },
    openRejectDemandDialog: function openRejectDemandDialog() {
      this.$emit.apply(this, ['openRejectDemandDialog'].concat(Array.prototype.slice.call(arguments)));
    },
    handleAssign: function handleAssign() {
      this.$emit.apply(this, ['handleAssign'].concat(Array.prototype.slice.call(arguments)));
    },
    handlePushDemand: function handlePushDemand() {
      this.$emit.apply(this, ['openPushAdvDialog'].concat(Array.prototype.slice.call(arguments)));
    },
    handleSubmitDemand: function handleSubmitDemand(demand) {
      this.commonHandler({
        promise: submitDemand,
        param: demand.id,
        successMsg: '提交成功！'
      });
    },
    handleDeleteDemand: function handleDeleteDemand(obj) {
      this.commonHandler({
        promise: deleteDemand,
        param: obj.id,
        successMsg: '删除成功！'
      });
    },
    handleRevocationDemand: function handleRevocationDemand(demand) {
      this.commonHandler({
        promise: revocationDemand,
        param: demand.id,
        successMsg: '撤回需求成功！'
      });
    },
    handleRevocationDesigner: function handleRevocationDesigner(obj) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.commonHandler({
                  promise: revocationDesigner,
                  param: obj.id,
                  successMsg: '撤回成功！'
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleRevocationPlan: function handleRevocationPlan(obj) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.commonHandler({
                  promise: revocationPlan,
                  param: {
                    id: obj.id
                  },
                  successMsg: '撤回成功！'
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    handleRevocationConfigure: function handleRevocationConfigure(obj) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.commonHandler({
                  promise: revocationConfigure,
                  param: {
                    id: obj.id
                  },
                  successMsg: '撤回成功！'
                });

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    handleStartDevTask: function handleStartDevTask(row) {
      this.commonHandler({
        promise: startDevTask,
        param: {
          id: row.id
        },
        successMsg: '开始研发！'
      });
    },
    handleGenerateInvoices: function handleGenerateInvoices(obj) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.commonHandler({
                  promise: genBill,
                  param: {
                    demand_id: obj.id
                  },
                  successMsg: '账单生成中'
                });

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    editPayment: function editPayment(data, type) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(type === 'close-pay')) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return _this6.$store.dispatch('demand/payment/updateInfo', _extends({}, data.payment, {
                  currency: data.payment.currency,
                  crm_contract_no: data.payment.crm_contract_no,
                  payment_id: data.payment_id,
                  id: data.id
                }));

              case 3:
                if (!(type === 'payment')) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 6;
                return _this6.$store.dispatch('demand/payment/updateInfo', _extends({}, data.payment, {
                  is_pay: data.is_pay,
                  id: data.id
                }));

              case 6:
                _context5.next = 8;
                return _this6.$store.dispatch('demand/payment/openDialog', {
                  title: type === 'close-pay' ? '补充结算金额' : '编辑结算金额',
                  type: type
                });

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    isDesign: function isDesign(demand) {
      return demand.category === 'design';
    },
    isSubmited: function isSubmited(demand) {
      return demand.status === 'submited';
    },
    isConfirmed: function isConfirmed(demand) {
      return demand.status === 'confirmed';
    },
    isPlanned: function isPlanned(demand) {
      return demand.status === 'planned';
    },
    isDevRejected: function isDevRejected(demand) {
      return demand.status === 'dev_rejected';
    },
    isDevConfirmed: function isDevConfirmed(demand) {
      return demand.status === 'dev_confirmed';
    },
    isDevOngoing: function isDevOngoing(demand) {
      return demand.status === 'dev_ongoing';
    },


    // 需求类型=交互素材
    isInteractiveCreation: function isInteractiveCreation(demand) {
      return demand.type === 1;
    },


    // 需求类型=非交互素材
    isNonInteractiveCreation: function isNonInteractiveCreation(demand) {
      return demand.type === 2;
    },
    isEditPaymentOrBillButtonVisible: function isEditPaymentOrBillButtonVisible(demand, btnName) {
      // 需求列表不需要展示
      if (this.$route.name === 'butler.demand-list') return false;

      // 非设计项目没有结算相关数据
      if (!this.isDesign(demand)) return false;

      // 已经生成账单则不展示
      if (demand.payment && demand.payment.is_gen_bill === 1) return false;

      // 「生成账单」按钮在有结算数据时才展示
      if (btnName === 'bill' && demand.payment_id === 0) return false;

      // 「生成账单」按钮在预付比例为0或者设置为不预付时不展示
      if (btnName === 'bill' && demand.payment && (demand.payment.is_prepaid === 2 || demand.payment.prepaid_percent === 0)) {
        return false;
      }

      if (this.isInteractiveCreation(demand) && (this.isSubmited(demand) || this.isConfirmed(demand) || this.isPlanned(demand) || this.isDevRejected(demand) || this.isDevConfirmed(demand) || this.isDevOngoing(demand))) {
        return true;
      }
      if (this.isNonInteractiveCreation(demand) && (this.isSubmited(demand) || this.isConfirmed(demand) || this.isPlanned(demand) || this.isDevRejected(demand) || this.isDevConfirmed(demand) || this.isDevOngoing(demand))) {
        return true;
      }
      return false;
    },
    handleCreateGMTmp: function handleCreateGMTmp(demand) {
      console.log('复制为通用模板', demand);
      this.$emit('handleCopyTemplate', {
        source: 'demand',
        src_demand_id: demand.id
      });
    },
    handleUpdateGMTmp: function handleUpdateGMTmp(demand) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var title, hasCheckTemplate;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('更新通用模板', demand);
                title = '将生成一个待检查模板，请检查模板打组情况后上线';
                _context6.next = 4;
                return _this7.getTemplateList({
                  type: 'gm',
                  id: demand.ext_gm_template_id
                });

              case 4:
                hasCheckTemplate = _context6.sent;

                if (hasCheckTemplate) {
                  title = '存在未上线的待检查模板，此次更新会将覆盖待检查模板，是否确定';
                }

                _this7.$confirm(title, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  if (demand.bind_project_id === 0) {
                    _this7.$emit('openGMTmpDialog', demand, 'gm');
                  } else {
                    _this7.$emit('handleUpdateTemplate', {
                      id: demand.id,
                      type: 'gm'
                    });
                  }
                });

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    handleUpdateDMTmp: function handleUpdateDMTmp(demand) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var title, hasCheckTemplate;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('更新定制项目', demand);
                title = '将生成一个待检查的创意方向，请检查创意方向打组情况后上线';
                _context7.next = 4;
                return _this8.getDmPendingTemplateList({
                  type: 'dm',
                  id: demand.creative_id
                });

              case 4:
                hasCheckTemplate = _context7.sent;

                if (hasCheckTemplate) {
                  title = '只允许同时存在一个待检查的创意方向，若继续则会将原待检查创意方向更新';
                }

                _this8.$confirm(title, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  if (demand.bind_project_id === 0) {
                    _this8.$emit('openGMTmpDialog', demand, 'dm');
                  } else {
                    _this8.$emit('handleUpdateTemplate', {
                      id: demand.id,
                      type: 'dm'
                    });
                  }
                });

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    getTemplateList: function getTemplateList(params) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return checkPending(params);

              case 2:
                res = _context8.sent;
                return _context8.abrupt('return', res.data.data > 0);

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },


    // 筛选“待检查”状态的创意方向数据
    getDmPendingTemplateList: function getDmPendingTemplateList(params) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var res;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return checkPending(params);

              case 2:
                res = _context9.sent;
                return _context9.abrupt('return', res.data.data > 0);

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    }
  }
};